"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetWithdraw = exports.withdrawTransactionFound = exports.closeWithdrawModal = exports.failTransaction = exports.performNonEVMWithdraw = exports.performEVMWithdraw = exports.performWithdraw = void 0;
const WalletWithdrawalSlice_1 = require("./WalletWithdrawalSlice");
const serverRequest = __importStar(require("../../../common-client/axiosApiClient"));
const Web3Helper_1 = __importDefault(require("../../../helper/web3/Web3Helper"));
const react_hot_toast_1 = __importDefault(require("react-hot-toast"));
const algorandHelper_1 = require("../../../helper/AlgoSDK/algorandHelper");
const algorandServerRequest = __importStar(require("./WalletWithdrawalClient"));
const constants_1 = require("../../../helper/constants");
const bridgeAbi = __importStar(require("../../../helper/bridgePool.json"));
const { actions } = WalletWithdrawalSlice_1.walletWithdrawalSlice;
const performWithdraw = (txId, networkClient) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    // console.log("start withdrawal");
    dispatch(actions.startWithdraw({
        receiveTransactionId: txId,
    }));
    yield serverRequest
        .withdraw(txId)
        .then((response) => __awaiter(void 0, void 0, void 0, function* () {
        // console.log(response.data, "withdrawal response");
        const request = response.data;
        const web3Instance = new Web3Helper_1.default(networkClient);
        web3Instance
            .sendTransactionAsync((txId) => dispatch(actions.transactionIdReceivedWithdrawal({
            transactionId: txId,
        })), [request])
            .then((response) => __awaiter(void 0, void 0, void 0, function* () {
            // console.log(response, "send transactions withdraw");
            yield serverRequest
                .updateWithdrawItemAddTransaction(txId, response.split("|")[0])
                .then((response) => {
                // console.log(response.data, "updateWithdrawItemAddTransaction");
                dispatch(actions.withdrawTransactionFound());
            });
            // await serverRequest
            //   .updateWithdrawItemPendingTransactions(response.split("|")[0])
            //   .then((res) => {
            //     console.log(res.data);
            //   });
        }))
            .catch((err) => {
            // console.log(err, "err message");
            react_hot_toast_1.default.error((err === null || err === void 0 ? void 0 : err.message) || "Unable to swap.");
            dispatch(actions.closeWithdrawModal());
            dispatch(actions.withdrawTransactionfail());
        });
    }))
        .catch((err) => {
        // console.log(err, "err message");
        react_hot_toast_1.default.error((err === null || err === void 0 ? void 0 : err.message) || "Unable to swap.");
        dispatch(actions.closeWithdrawModal());
        dispatch(actions.withdrawTransactionfail());
    });
});
exports.performWithdraw = performWithdraw;
const performEVMWithdraw = (item, web3Client, userAddress) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    dispatch(actions.startWithdraw({
        receiveTransactionId: item.id,
    }));
    const w = yield algorandServerRequest.getWithdrawItem(item.id);
    console.log(w.data.body.tx);
    const contract = new web3Client.eth.Contract(bridgeAbi.abi, constants_1.BRIDGE_CONTRACTS[w.data.body.tx.sendNetwork]);
    const params = {
        from: userAddress,
        to: constants_1.BRIDGE_CONTRACTS[w.data.body.tx.sendNetwork],
        value: 0,
        // gas: 39000,
        data: contract.methods
            .withdrawSigned(w.data.body.tx.payBySig.token, w.data.body.tx.payBySig.payee, w.data.body.tx.payBySig.amount, w.data.body.tx.payBySig.salt || w.data.body.tx.payBySig.swapTxId, w.data.body.tx.payBySig.signature ||
            w.data.body.tx.payBySig.signatures[0].signature)
            .encodeABI(),
    };
    yield web3Client.eth
        .sendTransaction(params)
        .on("transactionHash", (hash) => {
        console.log({ hash }, "transactionHash");
        dispatch(actions.transactionIdReceivedWithdrawal({
            transactionId: hash,
        }));
    })
        .on("receipt", (receipt) => {
        console.log({ receipt });
        return algorandServerRequest
            .newWithdrawItem(item.id, {
            receiveTransaction: receipt.transactionHash,
            used: "completed",
        })
            .then(() => dispatch(actions.withdrawTransactionFound()));
    })
        .on("error", (err) => {
        console.log(err === null || err === void 0 ? void 0 : err.message);
        dispatch(actions.closeWithdrawModal());
        dispatch(actions.withdrawTransactionfail());
    });
});
exports.performEVMWithdraw = performEVMWithdraw;
const performNonEVMWithdraw = (item) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    dispatch(actions.startWithdraw({
        receiveTransactionId: item.id,
    }));
    yield (0, algorandHelper_1.withdraw)(item.algorandWalletAddress, Number(item.payBySig.token), Number(item.payBySig.amount), //Number(item.receiveAmount),
    item.payBySig.hash, item.payBySig.messageHash.replace("0x", ""), item.payBySig.signature.replace("0x", ""), item.payBySig.payee, item.payBySig.salt, (txId) => dispatch(actions.transactionIdReceivedWithdrawal({
        transactionId: txId,
    })))
        .then((response) => {
        return algorandServerRequest
            .newWithdrawItem(item.id, {
            // receiveTransactionId: response.txId,
            sendAmount: item.receiveAmount,
            used: "completed",
        })
            .then(() => {
            dispatch(actions.withdrawTransactionFound());
        });
    })
        .catch((err) => {
        // console.log(err, "err message");
        react_hot_toast_1.default.error((err === null || err === void 0 ? void 0 : err.message) || "Unable to Withdraw.");
        dispatch(actions.closeWithdrawModal());
        dispatch(actions.withdrawTransactionfail());
    });
});
exports.performNonEVMWithdraw = performNonEVMWithdraw;
const failTransaction = () => (dispatch) => {
    dispatch(actions.withdrawTransactionfail());
};
exports.failTransaction = failTransaction;
const closeWithdrawModal = () => (dispatch) => {
    dispatch(actions.closeWithdrawModal());
};
exports.closeWithdrawModal = closeWithdrawModal;
const withdrawTransactionFound = () => (dispatch) => {
    dispatch(actions.withdrawTransactionFound());
};
exports.withdrawTransactionFound = withdrawTransactionFound;
const resetWithdraw = () => (dispatch) => {
    dispatch(actions.resetWithdraw());
};
exports.resetWithdraw = resetWithdraw;
//# sourceMappingURL=WalletWithdrawalActions.js.map